import { featureRoute } from '../helpers';
import { DaySaveStages } from '../../constants/AppConstants';

module.exports = featureRoute('enableDaySave', DaySaveStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/daySave/Search').default);
        }, 'daysave');
    }
});



// WEBPACK FOOTER //
// ./src/routes/DaySave/Search.js